import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './loginadmin.css';

const AdminLoginLoo = () => {
  const [emailLoo, setEmailLoo] = useState('');
  const [passwordLoo, setPasswordLoo] = useState('');
  const [errorMessageLoo, setErrorMessageLoo] = useState('');
  const navigateLoo = useNavigate();
  const handleLoginLoo = async (e) => {
    e.preventDefault();
    setErrorMessageLoo(''); // Clear previous errors

    try {
      const responseLoo = await axios.post(
        'https://back.varankal.com/auth/admin-login', // ✅ Updated API endpoint
        { email: emailLoo, password: passwordLoo },
        { withCredentials: true }
      );

      if (responseLoo.status === 200) {
        console.log('Admin logged in:', responseLoo.data);

        // ✅ Save token & user info to localStorage
        localStorage.setItem('adminTokenLoo', responseLoo.data.token);
        localStorage.setItem('adminUserLoo', JSON.stringify(responseLoo.data.user));

        // ✅ Redirect to Admin Dashboard
        navigateLoo('/admin/dashboard');
      } else {
        setErrorMessageLoo('Login failed. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      setErrorMessageLoo(error.response?.data?.message || 'An error occurred. Please try again.');
    }
  };

  return (
    <div className="admin-login-containerLoo">

      <form className="login-formLoo" onSubmit={handleLoginLoo}>

        {errorMessageLoo && <p className="error-messageLoo">{errorMessageLoo}</p>}
        <h2 className="titleLoo">Admin Login</h2>
        <div className="input-groupLoo">
          <label className="labelLoo">Email:</label>
          <input
            type="email"
            value={emailLoo}
            onChange={(e) => setEmailLoo(e.target.value)}
            required
            className="inputLoo"
          />
        </div>

        <div className="input-groupLoo">
          <label className="labelLoo">Password:</label>
          <input
            type="password"
            value={passwordLoo}
            onChange={(e) => setPasswordLoo(e.target.value)}
            required
            className="inputLoo"
          />
        </div>

        <button type="submit" className="submit-buttonLoo">Login</button>
      </form>
    </div>
  );
};

export default AdminLoginLoo;
